export const LEGAL_PAGES = [
  {
    slug: "privacy",
    title: "Privacy Policy",
    updated: "Last updated June 2026",
    intro: "This policy explains how STETH handles your information.",
    blocks: [
      {
        h: "Information we collect",
        bullets: [
          "Account details you provide: name, email, age, gender, profession, specialty, optional license or work-ID information, city, bio and photos.",
          "Usage data such as swipes, matches and messages needed to operate the service.",
          "Device and log information used to keep the service secure and reliable.",
        ],
      },
      {
        h: "How we use it",
        bullets: [
          "To create your profile, show you relevant people, enable matching and messaging, and keep the community safe.",
          "To verify healthcare professional status when you choose to submit verification.",
          "We do not sell your personal information.",
        ],
      },
      {
        h: "Photos and content",
        bullets: ["Photos you upload are stored securely and shown to other members as part of your profile."],
      },
      {
        h: "Your choices",
        bullets: [
          "You can edit or remove profile details at any time, block users, and request account deletion in the app.",
          "Deleting your account removes your profile and associated personal data.",
        ],
      },
      {
        h: "Data retention & security",
        bullets: [
          "We retain your information while your account is active and delete it after account deletion, except where retention is required by law.",
          "We use industry-standard safeguards to protect your data.",
        ],
      },
      {
        h: "Children",
        bullets: ["STETH is strictly for adults 18 and older. We do not knowingly collect data from anyone under 18."],
      },
      { h: "Contact", bullets: ["Questions about privacy? Reach us at support@stethdating.com."] },
    ],
  },
  {
    slug: "terms",
    title: "Terms of Use (EULA)",
    updated: "Last updated June 2026",
    intro: "By using STETH you agree to these Terms of Use (our End User License Agreement).",
    blocks: [
      {
        h: "Eligibility",
        bullets: [
          "You must be at least 18 years old to use STETH.",
          "You are responsible for the accuracy of the information on your profile.",
        ],
      },
      {
        h: "Acceptable use & zero tolerance",
        bullets: [
          "Follow our Community Guidelines. Do not misuse the service, harass others, or post objectionable or prohibited content.",
          "There is zero tolerance for objectionable content or abusive behavior. Violations may result in immediate removal.",
        ],
      },
      {
        h: "Content & moderation",
        bullets: [
          "You retain ownership of content you post but grant us a license to display it within the service.",
          "We review reports and may remove content or terminate accounts that violate these terms within 24 hours of a report.",
        ],
      },
      {
        h: "Safety",
        bullets: [
          "STETH provides in-app tools to report and block other users. You are responsible for your own safety when interacting with or meeting other members.",
        ],
      },
      {
        h: "No warranty",
        bullets: ['STETH is provided "as is." We are not responsible for the conduct of any user, online or offline.'],
      },
      { h: "Changes", bullets: ["We may update these terms and will notify you of material changes."] },
      { h: "Contact", bullets: ["Questions about these terms? Reach us at support@stethdating.com."] },
    ],
  },
  {
    slug: "guidelines",
    title: "Community Guidelines",
    updated: "Last updated June 2026",
    intro:
      "STETH is a community of healthcare professionals looking for genuine connection. To keep it safe and respectful, everyone agrees to these guidelines.",
    blocks: [
      {
        h: "Be real",
        bullets: [
          "Use your own recent photos and accurate information about yourself and your profession.",
          "Only healthcare professionals and students should represent themselves as such.",
        ],
      },
      {
        h: "Be respectful",
        bullets: [
          "No harassment, hate speech, threats, or discrimination of any kind.",
          "No unsolicited explicit content. Keep photos and messages appropriate.",
        ],
      },
      {
        h: "Be honest and safe",
        bullets: [
          "Do not scam, solicit money, or promote external services.",
          "Never share patient information or anything that violates privacy or workplace policy.",
        ],
      },
      {
        h: "Zero tolerance",
        bullets: [
          "Nudity or sexually explicit content, content involving minors, and abusive behavior result in immediate removal.",
        ],
      },
      {
        h: "Reporting & moderation",
        bullets: [
          "Use the Report and Block tools on any profile or chat. Every report is reviewed and we act on violations, including removing accounts, within 24 hours.",
        ],
      },
    ],
  },
  {
    slug: "safety",
    title: "Dating Safety Tips",
    updated: "Last updated June 2026",
    intro: "Your safety comes first. A few tips for meeting people on STETH.",
    blocks: [
      {
        h: "Online",
        bullets: [
          "Keep conversations on the app until you feel comfortable.",
          "Never send money or share financial information.",
          "Be cautious with anyone who avoids video or keeps making excuses to meet.",
        ],
      },
      {
        h: "Meeting in person",
        bullets: [
          "Meet in a public place the first few times.",
          "Tell a friend or colleague where you're going and when you'll be back.",
          "Arrange your own transportation to and from the date.",
          "Stay sober enough to stay in control.",
        ],
      },
      {
        h: "Trust your instincts",
        bullets: [
          "If something feels off, it's okay to leave.",
          "Use Block and Report on anyone who makes you uncomfortable.",
        ],
      },
      {
        h: "Emergencies",
        bullets: ["If you're ever in immediate danger, contact your local emergency services."],
      },
    ],
  },
  {
    slug: "support",
    title: "Support & Contact",
    updated: "Last updated June 2026",
    intro: "Need a hand? We're here to help.",
    blocks: [
      {
        h: "Email support",
        bullets: ["support@stethdating.com. We typically reply within 1–2 business days."],
      },
      {
        h: "Trust & safety",
        bullets: [
          "To report a user, use the Report option on their profile or in chat.",
          "For urgent safety concerns, email support@stethdating.com.",
        ],
      },
      {
        h: "Account help",
        bullets: [
          "Manage your profile, preferences and blocked users from the Profile tab.",
          "You can delete your account and data at any time from Settings.",
        ],
      },
    ],
  },
];
